import { api } from "../configs/axiosConfigs";

export const VerificationsAPI = {
    getVerification: async (data?: any) => {
        const response = await api
            .get('/verifications', { params: { ...data } })
            .then(response => response.data)
            .catch((error) => {
                return error.response.data
            });
        return response;
    }
}